import script from "./JobManager.vue?vue&type=script&setup=true&lang=js"
export * from "./JobManager.vue?vue&type=script&setup=true&lang=js"

import "./JobManager.vue?vue&type=style&index=0&id=da8b0fb6&scoped=true&lang=css"
script.__scopeId = "data-v-da8b0fb6"

export default script